import type { PiniaPluginContext } from 'pinia'

/**
 * Pinia setup-stores (defineStore('id', () => {...})) don't get a built-in
 * $reset() the way option stores do. This plugin snapshots each store's initial
 * state when it's first created and adds a working $reset() that restores it.
 *
 * Used by resetUserScopedStores() so switching organizations can drop all
 * per-org cached data without a full page reload.
 */
export function resetStorePlugin({ store }: PiniaPluginContext) {
  // Snapshot the initial state at store-creation time (before any actions run).
  let initialState: Record<string, unknown> = {}
  try {
    initialState = JSON.parse(JSON.stringify(store.$state))
  } catch {
    initialState = {}
  }

  store.$reset = () => {
    try {
      const fresh = JSON.parse(JSON.stringify(initialState))
      store.$patch((state: Record<string, unknown>) => {
        Object.assign(state, fresh)
      })
    } catch {
      // non-fatal: a store that can't be JSON-cloned just won't hard-reset
    }
  }
}
